import { useState } from 'react';
import InitFilters from './components/InitFiltering';
const useCustomHook = () => {
  const [loading, setLoading] = useState(false);
  const [, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [selectedRow, setSelectedRow] = useState(false);
  const [removeDialog, setRemoveDialog] = useState({});
  const [filters, setFilters] = useState(InitFilters());
  const [isLoadingFilter, setIsLoadingFilter] = useState(false);
  const [copyOriginalFilter, setCopyOriginalFilter] = useState(null);
  const [copyTempFilter, setCopyTempFilter] = useState(null);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [copyOpenDgFilter, setCopyOpenDgFilter] = useState(null);
  const [isLoadingCheckSuperAdmin, setIsLoadingCheckSuperAdmin] = useState(true);
    const [superAdminObject, setSuperAdminObject] = useState({ isAdmin: false, getData: false });
  return {
    loading,
    setLoading,
    setFilterParams,
    size,
    setSize,
    page, setPage,
    loadingBtn, setLoadingBtn,
    removeDialog, setRemoveDialog,
    selectedRow, setSelectedRow,
    filters, setFilters,
    isLoadingFilter, setIsLoadingFilter,
    copyOriginalFilter, setCopyOriginalFilter,
    copyTempFilter, setCopyTempFilter,
    openFilterDialog, setOpenFilterDialog,
    copyOpenDgFilter, setCopyOpenDgFilter,
    isLoadingCheckSuperAdmin, setIsLoadingCheckSuperAdmin,
    superAdminObject, setSuperAdminObject

  };
};

export default useCustomHook;
